import e from "./SidebarElement.vue2.js";
import o from "../../_virtual/_plugin-vue_export-helper.js";
const a = /* @__PURE__ */ o(e, [["__scopeId", "data-v-e7568968"]]);
export {
  a as default
};
